import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography } from '@inplayer-org/inplayer-ui';

// utils
import { url } from 'utils/validators';

// Types
import RootState from 'ducks/RootState';
import { Domain } from 'pages/MerchantPages/Settings/Auth/Oauth/components/modals/EnableSSO';

// Components
import DomainsForm from 'pages/MerchantPages/Settings/Auth/Oauth/components/DomainsForm';
import StyledContainer from 'components/StyledContainer';

// Actions
import { addApplicationDomains } from 'ducks/merchantDucks/oauth/actions';

const { Cell } = Grid;

interface OwnProps {
  domains: Array<Domain>;
  handleCloseModal: () => void;
}

type Props = OwnProps;

const Domains: FunctionComponent<Props> = ({ domains: propsDomains, handleCloseModal }: Props) => {
  const dispatch = useDispatch();

  const subdomain = useSelector((state: RootState) => state.oauth.subdomain);
  const merchantUuid = useSelector((state: RootState) => state.auth.user.uuid);

  const handleModalClose = () => {
    handleCloseModal();
  };

  const createDomains = (data: Array<{ id: number; domain: string }>) => {
    const domains: Array<any> = data.map(({ domain }: { domain: string }) => domain);

    let error = false;
    domains.forEach((domain: any) => {
      if (url(domain) === 'Invalid URL') {
        error = true;
      }
    });

    dispatch(addApplicationDomains(merchantUuid.replace(/-/g, ''), domains));

    if (!error) {
      handleModalClose();
    }
  };

  const nosubDomain = !subdomain;

  const description = nosubDomain
    ? `Once SSO is enabled we will create your unique merchant sub-domain where user
        access tokens will be stored. Afterwards you will be able to add domains (URLs) where you want your users to be
        able to be logged in concurrently.`
    : 'Manage domains where users would be able to be logged in concurrently.';

  return (
    <>
      <StyledContainer columns="10% 1fr 10%" margin="1rem 0 2rem 0" rowGap="1rem">
        <Cell left={2}>
          <Typography variant="p">{description}</Typography>
        </Cell>
        <Cell left={2}>
          <DomainsForm
            domains={propsDomains}
            nosubDomain={nosubDomain}
            onSubmit={createDomains}
            handleModalClose={handleModalClose}
          />
        </Cell>
      </StyledContainer>
    </>
  );
};

export default Domains;
